import React, { useState, useEffect } from "react";
import Barcode from "react-barcode";
const BarCode = (props) => {
  const [barcodeValues, setBarcodeValues] = useState("");
  const [barcodeHeight, setBarcodeHeight] = useState("");
  const [barcodeWidth, setBarcodeWidth] = useState("");
  const [barcodeFontSize, setBarcodeFontSize] = useState("");
  const [barcodeDisplayValue, setBarcodeDisplayValue] = useState("");

  useEffect(() => {
    setBarcodeValues(props.barcodeValuess);
    setBarcodeHeight(props.barcodeHeights);
    setBarcodeWidth(props.barcodeWidths);
    setBarcodeFontSize(props.barcodeFontSizes);
    setBarcodeDisplayValue(props.displayValues);
  }, [
    props.barcodeValuess,
    props.barcodeHeights,
    props.barcodeWidths,
    props.barcodeFontSizes,
    props.displayValues,
  ]);

  //<BarCode barcodeValuess={fileNumber} barcodeHeights='15' barcodeWidths='1' barcodeFontSizes='10' displayValues= 'true' />
  return (
    <>
      <Barcode
        value={barcodeValues}
        height={barcodeHeight}
        width={barcodeWidth}
        fontSize={barcodeFontSize}
        displayValue={barcodeDisplayValue}
        textMargin = '0'
        marginTop = '5'
        marginBottom = '5'
      />
    </>
  );
};

export default BarCode;
